var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggregate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.097L1.097 2l3.756 3.757c.584.583 1.377.91 2.201.91h3.967L9.792 5.43l1.097-1.097L14 7.444l-3.111 3.112-1.097-1.097 1.23-1.237H7.053c-.824 0-1.617.327-2.2.91L1.096 12.89 0 11.792l4.348-4.348L0 3.097z"
  })));
}
export default SvgAggregate;